import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { StateWithNotifications } from '../store/notificationsSlice';

export const useAppWithNotificationsSelector: TypedUseSelectorHook<StateWithNotifications> = useSelector;
